import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('question_options')
export class QuestionOption {
    @PrimaryGeneratedColumn()
    id: number;

    @Column('int', { name: 'question_id' })
    questionId: number;

    @Column('tinyint', { name: 'option_no' })
    optionNo: number;

    @Column('longtext', { name: 'option_text', nullable: true })
    optionText: string;
}
